import { grey } from "@mui/material/colors";

import { drawerStyles } from "components/Drawer/reusableDrawerStyles";

const styles = {
  ...drawerStyles,
  templateSelect: {
    ml: -1,
    "& .MuiSelect-select": {
      display: "flex",
      alignItems: "center",
    },
  },
  templateMenuItem: {
    display: "flex",
    alignItems: "center",
  },
  templateMenuName: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: { xs: 240, md: 500 },
    color: "primary.main",
  },
  noSelectBorder: {
    boxShadow: "none",
    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    color: "primary.main",
  },
  templateWidth: {
    maxWidth: { xs: "auto", md: "15vw" },
  },
  fillVariable: {
    textTransform: "none",
    borderRight: `1px solid ${grey[200]}`,
    borderRadius: 0,
  },
};

export default styles;
